// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"47f3874a","372":"f7fcd7eb","434":"48591c3d","738":"d092e499","787":"1e7ae348","856":"e4a0cd6c"}[chunkId] + ".chunk.js";
};